<template>
  <div id="cookie" class="cookie-body-container">
    <div class="cookie-body-content" v-show="isShow">
      <div v-if="cookie_diaVisited" class="detail_con">
        <div class="cookie_title">
          Cookie Preferences
          <span class="closeBtn" @click="closeDio">X</span>
          </div>
        <!-- <div>X</div> -->
        <div class="cookie_three">
          <div class="content">Cookies are small files which, when placed on your device, enable us to provide certain features and functionality of CZUR websites and online services to you. We use the following types of cookies on our websites. View Cookie Policy for full details.<br></div>

          <div class="headerTitle"><i class="el-icon-circle-check"></i><span class="headerTest">Strictly Necessary Cookies</span></div>
          <div class="content">These cookies are essential for you to use our websites, such as the cookies used for carrying out the transmission of a communication, the cookies that record requests for information from the Internet and block web attacks so as to ensure web security, the cookies that are strictly necessary for us to provide information society services that you request. You must accept strictly necessary cookies to be able to use our websites.</div>

          <div class="headerTitle"><i class="el-icon-remove-outline"></i><span class="headerTest">Preference Cookies</span></div>
          <div class="content">These cookies are also known as "functionality cookies", these cookies allow us to remember choices you have made through your use of our websites, what region you are in, or what your username and password are so you can automatically log in. These cookies can help us reallocate work load among our servers and enable our webpages to respond faster.</div>

          <div class="headerTitle"><i class="el-icon-remove-outline"></i><span class="headerTest">Statistics Cookies</span></div>
          <div class="content lastContent">These cookies are also known as "performance cookies", these cookies collect information about how you use our websites, like which web pages you visited and which links you clicked on. These cookies can help us to improve your browsing experience on our websites.</div>
        </div>
        <div class="dia_but">
          <span class="btn1" @click="Required_Only">Required Only</span>
          <span class="btn2" @click="accept_all">Accept All</span>
        </div>
      </div>
      <div class="footer_con" v-if="footer_diaVisited">
        <div class="headerTest">
          We Value Your Privacy
          <span class="morenBtn" @click="Required_Only">X</span>
        </div>
        <div class="footer_text">
          We use  cookies to maintain the essential functionality of our website and
          detect website performance to help us improve our website and online products and services, as well as improving your experience by providing personalized content.
          You can manage your settings at any time through <span class="clicksty" @click="preferClick">Cookie Preferences</span> or read our <span class="clicksty" @click="clickPrivact">Cookie Policy</span> to learn more.
        </div>
        <div class="footer_but">
          <span class="btn1" @click="openDia">Cookie Preferences</span>
          <span class="btn2" @click="accept_all">Accept All</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cookie',
  data () {
    return {
      isShow: false,
      cookie_diaVisited: false,
      footer_diaVisited: false,
      cookie_necessary: 1, // 1代表勾选，0代表没勾选
      cookie_preference: 0,
      cookie_statistics: 0
    }
  },
  mounted () {
    // this.$nextTick(() => {
    //   this.isShow = true
    // })
    setTimeout(() => {
      this.isShow = true
    }, 100)
  },
  created () {
    console.log(localStorage.getItem('cookie_necessary'), '=====')
    if (localStorage.getItem('cookie_necessary') === '1') {
      this.footer_diaVisited = false
    } else {
      this.footer_diaVisited = true
    }
  },
  methods: {
    clickPrivact () {
      window.open('https://privacy.czur.cc/privacy_en')
    },
    accept_all () {
      this.cookie_necessary = 1
      this.cookie_preference = 1
      this.cookie_statistics = 1
      this.Required_Only()
    },
    Required_Only: function () {
      localStorage.setItem('cookie_necessary', this.cookie_necessary)
      localStorage.setItem('cookie_preference', this.cookie_preference)
      localStorage.setItem('cookie_statistics', this.cookie_statistics)
      this.footer_diaVisited = false
      this.cookie_diaVisited = false
    },
    openDia: function () {
      this.cookie_diaVisited = true
    },
    closeDio: function () {
      this.cookie_diaVisited = false
    },
    preferClick: function () {
      this.cookie_diaVisited = true
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#cookie
  margin .25rem
  font-size 0.18rem
  // line-height 0.24rem
  text-align justify
  text-indent: 0 !important
  // height auto
  div
    text-indent: 0 !important
  .footer_con
    position: fixed;
    bottom: -1%;
    box-shadow: 4px 4px 15px #b6b6b6;
    width: 99%;
    left: -0.005rem;
    padding: 1%;
    background-color: #fff;
    padding-left 12%
  .clicksty
    color blue
    cursor pointer
  .detail_con
    position: fixed;
    background-color: #fff;
    width: 50%;
    top: 10%;
    left: 24%;
    box-shadow: 4px 4px 15px #B6B6B6;
    padding: 25px;
    color: #3D3D3D
    border-radius: 0.1rem;
    height: 57%
    overflow: auto
  .cookie_title
    color: #3D3D3D;
    font-weight: bold;
    font-size: 0.23rem;
    border-bottom: 1px solid #D8D8D8;
    padding-bottom: 0.1rem;
    .closeBtn
      float: right
      cursor pointer
  .cookie_three
    padding-top  0.1rem;
  .el-icon-circle-check
    color: green;
    font-size: 0.25rem;
    font-weight: bold;
    width 0.3rem
    vertical-align: bottom
  .el-icon-remove-outline
    font-size: 0.25rem;
    font-weight: bold;
    width 0.3rem
    vertical-align: bottom
  .content
    padding-left 0.3rem
  .content:last-child
    border-bottom: 1px solid #D8D8D8;
    padding-bottom: 0.2rem;
  .headerTitle
    padding 0.1rem 0
  .headerTest
    font-weight: bold;
    font-size: 0.21rem;
    .morenBtn
      position: absolute;
      right: 13%;
      cursor pointer
  .footer_text
    width: 60%
    display: inline-block
  .btn1
    border: 1px solid #000;
    padding: 6px;
    border-radius: 8px;
    margin-right: 25px;
    cursor pointer
  .btn2
    background-color: #000;
    color: #fff;
    padding: 6px;
    border-radius: 8px;
    cursor pointer
  .dia_but
    display: inline-block;
    font-size: 0.18rem;
    vertical-align: top;
    margin-top: 0.12rem;
    margin-left: 0.3rem;
    padding-top: 0.2rem;
    float: right;
  .footer_but
    display: inline-block;
    font-size: 0.18rem;
    vertical-align: top;
    margin-top: 0.12rem;
    margin-left: 0.3rem;
</style>



// WEBPACK FOOTER //
// cookie.vue?c26ca6ce